import React from 'react'
import styled from 'styled-components'
import theme from 'styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 460px;
`
export const StyledContent = styled.div`
  color: ${theme.colors.heavyMetal};
  font-family: Greycliff CF;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 133%;
  letter-spacing: 0.18px;
  text-align: left;
  margin-bottom: 24px;
  a {
    color: ${theme.colors.heavyMetal};
    font-family: Greycliff CF;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.18px;
    text-decoration-line: underline;
  }
  @media (max-width: ${theme.breakpoints.mobile}) {
  }
`
export const Title = styled.div`
  color: ${theme.colors.obsidianBlack};
  font-family: Quincy CF;
  font-size: 44px;
  font-style: normal;
  font-weight: 400;
  line-height: 118%;
  letter-spacing: -0.44px;
  text-align: left;
  margin-bottom: 24px;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 32px;
    line-height: 128%;
  }
`

const OnboardingNonRxEmailSubmissionTikTok = (): JSX.Element => {
  return (
    <StyledContainer>
      <Title>Thanks for taking the quiz—we’re grateful you’ve come to Found!</Title>
      <StyledContent>
        You’ve qualified for the wellness path. The wellness program is taking a quick hiatus while
        we make it an even better and more successful experience for you. In the meantime, check out{' '}
        <a href={`${process.env.STORE_URL}/pages/blog`}>Found’s blog</a>, which will help you on
        your weight care journey. Submit your email to be notified once the wellness plan is
        available.
      </StyledContent>
    </StyledContainer>
  )
}

export default OnboardingNonRxEmailSubmissionTikTok
